import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import HubspotWrapper from '../Common/HubspotWrapper';
import { pluginPath } from '../../constants/leadinConfig';
import AsyncSelect from '../Common/AsyncSelect';
import { __ } from '@wordpress/i18n';
export default function FormSelector({ loadOptions, onChange, value, }) {
    return (_jsxs(HubspotWrapper, { pluginPath: pluginPath, children: [_jsx("p", { "data-test-id": "leadin-form-select", children: _jsx("b", { children: __('Select an existing form or create a new one from a template', 'leadin') }) }), _jsx(AsyncSelect, { placeholder: __('Search for a form', 'leadin'), value: value, loadOptions: loadOptions, onChange: onChange })] }));
}
